/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import {
  TableView,
  TableHeader,
  Column,
  TableBody,
  Row,
  Cell,
  Item,
  Text,
  MenuTrigger,
  Menu,
  ActionButton,
  Button,
  Tooltip,
  TooltipTrigger,
  Link,
} from '@adobe/react-spectrum';
import More from '@spectrum-icons/workflow/More';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import { TableBox } from './Style';
import { getLocalDateTime } from '../../utils/utils';

function TableSearch(props) {
  const { tableData, isTaskSearch } = props;
  const [count, setCount] = useState(10);
  const [assigneeName, setAssigneeName] = useState('');

  const handleLoadMore = loadData => {
    const limit = 10;
    if (count < loadData.length) setCount(count + limit);
  };

  const handleAssignee = name => {
    const newName = name.split(' ');
    setAssigneeName(newName[2]);
  };

  return (
    <TableBox>
      <TableView
        aria-label="Example table with dynamic content"
        maxWidth="size-8000"
        density="spacious"
      >
        <TableHeader>
          <Column align="start" width="20%">
            Name
          </Column>
          {isTaskSearch ? (
            <Column width="13%">Assignments</Column>
          ) : (
            <Column width="15%">Owner</Column>
          )}
          <Column width="40%">
            Path
            <TooltipTrigger delay={0} placement="end">
              <ActionButton isQuiet>
                <IoMdInformationCircleOutline
                  size={15}
                  style={{ marginLeft: '10px' }}
                />
              </ActionButton>
              <Tooltip>
                {isTaskSearch
                  ? 'Portfólio / Program / Project'
                  : 'Portfólio / Program'}
              </Tooltip>
            </TooltipTrigger>
          </Column>
          <Column align="center" width="7%">
            Status
          </Column>
          <Column width="13%">Planned completion Date</Column>
          <Column align="end" Width="7%" />
        </TableHeader>
        <TableBody items={tableData?.slice(0, count) || []}>
          {item => (
            <Row key={item?.ID}>
              <Cell>
                <TooltipTrigger delay={0} placement="end">
                  <ActionButton isQuiet>
                    {item.name ? item.name.slice(0, 22) : item.name}
                    {item.name.length > 22 ? '...' : ''}
                  </ActionButton>
                  <Tooltip> {item.name}</Tooltip>
                </TooltipTrigger>
              </Cell>
              {isTaskSearch ? (
                <Cell>
                  {item?.assignments[0]?.assignedTo?.name != null ? (
                    <TooltipTrigger delay={0} placement="end">
                      <ActionButton isQuiet>
                        {item.assignments[0]?.assignedTo?.name
                          ? item.assignments[0]?.assignedTo?.name.slice(0, 15)
                          : item.assignments[0]?.assignedTo?.name}
                        {item.assignments[0]?.assignedTo?.name.length > 15
                          ? '...'
                          : ''}
                      </ActionButton>
                      <Tooltip>{item.assignments[0]?.assignedTo?.name}</Tooltip>
                    </TooltipTrigger>
                  ) : (
                    <TooltipTrigger delay={0} placement="end">
                      {handleAssignee(item?.assignmentsListString)}
                      {assigneeName && (
                        <ActionButton isQuiet>
                          {assigneeName
                            ? assigneeName.slice(0, 15)
                            : assigneeName}
                          {assigneeName.length > 15 ? '...' : ''}
                        </ActionButton>
                      )}
                      <Tooltip>{assigneeName}</Tooltip>
                    </TooltipTrigger>
                  )}
                </Cell>
              ) : (
                <Cell>
                  <TooltipTrigger delay={0} placement="end">
                    <ActionButton isQuiet>
                      {item.owner.name
                        ? item.owner.name.slice(0, 15)
                        : item.owner.name}
                      {item.owner.name.length > 15 ? '...' : ''}
                    </ActionButton>
                    <Tooltip> {item.owner.name}</Tooltip>
                  </TooltipTrigger>
                </Cell>
              )}
              {isTaskSearch ? (
                <Cell>
                  <TooltipTrigger delay={0} placement="end">
                    <ActionButton isQuiet>
                      <Link variant="secondary" isQuiet>
                        <a
                          target="_blank"
                          href={`${item.workfrontEndpoint}/portfolio/${item?.project?.portfolio?.ID}/overview`}
                          rel="noreferrer"
                        >
                          {item?.project?.portfolio === null
                            ? '-'
                            : item?.project?.portfolio?.name
                            ? item?.project?.portfolio?.name.slice(0, 15)
                            : item?.project?.portfolio?.name}
                          {item?.project?.portfolio?.name.length > 15
                            ? '... /'
                            : ' /'}
                        </a>
                      </Link>
                    </ActionButton>
                    <Tooltip>{`${item?.project?.portfolio?.name}`}</Tooltip>
                  </TooltipTrigger>
                  <TooltipTrigger delay={0} placement="end">
                    <ActionButton isQuiet>
                      <Link variant="secondary" isQuiet>
                        <a
                          target="_blank"
                          href={`${item.workfrontEndpoint}/program/${item?.project?.program?.ID}/overview`}
                          rel="noreferrer"
                        >
                          {item?.project?.program === null
                            ? '-'
                            : item?.project?.program?.name
                            ? item?.project?.program?.name.slice(0, 15)
                            : item?.project?.program?.name}
                          {item?.project?.program?.name.length > 15
                            ? '... /'
                            : ' /'}
                        </a>
                      </Link>
                    </ActionButton>
                    <Tooltip>{`${item?.project?.program?.name}`}</Tooltip>
                  </TooltipTrigger>
                  <TooltipTrigger delay={0} placement="end">
                    <ActionButton isQuiet>
                      <Link variant="secondary" isQuiet>
                        <a
                          target="_blank"
                          href={`${item.workfrontEndpoint}/project/${item?.project?.ID}/overview`}
                          rel="noreferrer"
                        >
                          {item?.project === null
                            ? '-'
                            : item?.project?.name
                            ? item?.project?.name.slice(0, 15)
                            : item?.project?.name}
                          {item?.project?.name.length > 15 ? '...' : ' '}
                        </a>
                      </Link>
                    </ActionButton>
                    <Tooltip>{`${item?.project?.name}`}</Tooltip>
                  </TooltipTrigger>
                </Cell>
              ) : (
                <Cell>
                  <TooltipTrigger delay={0} placement="end">
                    <ActionButton isQuiet>
                      <Link variant="secondary" isQuiet>
                        <a
                          target="_blank"
                          href={`${item.workfrontEndpoint}/portfolio/${item?.portfolio?.ID}/overview`}
                          rel="noreferrer"
                        >
                          {item?.portfolio === null
                            ? '-'
                            : item?.portfolio?.name
                            ? item?.portfolio?.name.slice(0, 15)
                            : item?.portfolio?.name}
                          {item?.portfolio?.name.length > 15 ? '... /' : ' /'}
                        </a>
                      </Link>
                    </ActionButton>
                    <Tooltip>{`${item?.portfolio?.name}`}</Tooltip>
                  </TooltipTrigger>
                  <TooltipTrigger delay={0} placement="end">
                    <ActionButton isQuiet>
                      <Link variant="secondary" isQuiet>
                        <a
                          target="_blank"
                          href={`${item.workfrontEndpoint}/program/${item?.program?.ID}/overview`}
                          rel="noreferrer"
                        >
                          {item?.program === null
                            ? '-'
                            : item?.program?.name
                            ? item?.program?.name.slice(0, 15)
                            : item?.program?.name}
                          {item?.program?.name.length > 15 ? '...' : ''}
                        </a>
                      </Link>
                    </ActionButton>
                    <Tooltip>{`${item?.program?.name}`}</Tooltip>
                  </TooltipTrigger>
                </Cell>
              )}
              <Cell>{item.status}</Cell>
              <Cell>
                {moment(getLocalDateTime(item.plannedCompletionDate)).format(
                  'MMM DD, YYYY',
                )}
              </Cell>
              <Cell>
                <MenuTrigger>
                  <ActionButton isQuiet>
                    <More />
                  </ActionButton>
                  <Menu>
                    <Item key="share" textValue="share">
                      <Text UNSAFE_className="menuText">
                        <Link variant="secondary" isQuiet>
                          <a
                            target="_blank"
                            href={
                              isTaskSearch
                                ? `${item.workfrontEndpoint}/task/${item.ID}/overview`
                                : `${item.workfrontEndpoint}/project/${item.ID}/overview`
                            }
                            rel="noreferrer"
                          >
                            Workfront link
                          </a>
                        </Link>
                      </Text>
                    </Item>
                  </Menu>
                </MenuTrigger>
              </Cell>
            </Row>
          )}
        </TableBody>
      </TableView>
      {tableData?.length > count ? (
        <Button
          marginTop="20px"
          variant="cta"
          onPress={() => handleLoadMore(tableData)}
        >
          Show more
        </Button>
      ) : (
        ''
      )}
    </TableBox>
  );
}
TableSearch.propTypes = {
  tableData: PropTypes.array,
  isTaskSearch: PropTypes.bool,
};

TableSearch.defaultProps = {
  tableData: [],
  isTaskSearch: false,
};
export default TableSearch;
